'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { getIconAssetURL, useIcons } from './IconsProvider';
import { getIconStyle } from './getIconStyle';
/**
 * Renders an icon component from the library.
 * The icon is loaded as a standalone image.
 */
export const Icon = React.forwardRef(function Icon(props, ref) {
    const context = useIcons();
    const { icon: propIcon, iconStyle: propIconStyle = context.iconStyle, className = '', size, ...rest } = props;
    const [iconStyle, icon] = getIconStyle(propIconStyle, propIcon);
    const url = getIconAssetURL(context, iconStyle, icon);
    return (_jsx("svg", { ref: ref, ...rest, style: {
            maskImage: `url(${url})`,
            WebkitMaskImage: `url(${url})`,
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskPosition: 'center',
            WebkitMaskPosition: 'center',
            ...(size ? { width: size, height: size } : {}),
            ...rest.style,
        }, className: `gb-icon ${className}` }));
});
